/* Visage theme scripts: the bag (Shopify cart API), the face map, the shop filters, quick view, the skin quiz,
   the product page, collection filters and motion. Product data comes from the JSON blocks that each section prints. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const readJSON = (el, fallback) => { try { return JSON.parse(el.textContent); } catch (e) { return fallback; } };
  const CFG = readJSON($('#visage-config') || { textContent: '{}' }, {});
  const ROUTES = CFG.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search' };
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const narrow = matchMedia('(max-width: 760px), (max-aspect-ratio: 1/1)');
  const html = document.documentElement;
  html.classList.add('js');
  if (window.Shopify && window.Shopify.designMode) html.classList.add('shopify-design-mode');

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const STEP = { cleanse: 'Cleanse', treat: 'Treat', hydrate: 'Hydrate' };
  const NUM = { cleanse: 'I', treat: 'II', hydrate: 'III' };
  const STEPS = ['cleanse', 'treat', 'hydrate'];
  const CATS = { skin: 'Skincare', makeup: 'Makeup', hair: 'Hair', body: 'Body', tools: 'Tools', other: 'Other' };
  const WORDS = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'];
  const rate = (window.Shopify && window.Shopify.currency && +window.Shopify.currency.rate) || 1;
  const FREE = Math.round((+CFG.freeShipping || 0) * rate);

  function money(cents) {
    cents = Math.round(+cents || 0);
    const fix = (d, ts, ds) => {
      const [i, dec] = (cents / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (dec ? ds + dec : '');
    };
    const f = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.'), amount_with_space_separator: fix(2, ' ', ','),
      amount_no_decimals_with_space_separator: fix(0, ' ', ',')
    }[k] || fix(2, ',', '.')));
  }
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* ---------- catalog: every section prints the products it shows; the Shop section adds short names, steps and concerns ---------- */
  const CAT = new Map();
  function loadCatalog(root = document) {
    $$('script[data-catalog]', root).forEach(s => (readJSON(s, []) || []).forEach(p => {
      if (!p || !p.handle) return;
      const cur = CAT.get(p.handle);
      if (!cur) { CAT.set(p.handle, p); return; }
      for (const k in p) if (p[k] != null && cur[k] == null) cur[k] = p[k];
    }));
  }
  const nameOf = p => p.name || p.title;
  const firstVariant = p => (p.variants || []).find(v => v.available) || (p.variants || [])[0];
  const varies = p => new Set((p.variants || []).map(v => v.price)).size > 1;
  const priceLabel = p => (varies(p) ? 'From ' : '') + money(p.price);
  const kickerOf = p => p.step && NUM[p.step] ? `${NUM[p.step]}. ${STEP[p.step]}` : (p.cat && p.cat !== 'other' ? CATS[p.cat] : '');

  /* ---------- bag ---------- */
  let cart = CFG.cart || { items: [], item_count: 0, total_price: 0 };
  const inBag = h => (cart.items || []).some(i => i.handle === h);
  const stepsIn = () => new Set((cart.items || []).map(i => (CAT.get(i.handle) || {}).step).filter(Boolean));
  const jsonPost = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Try again.'); return j; });
  async function refreshCart() {
    const r = await fetch(ROUTES.cart + '.js', { headers: { Accept: 'application/json' } });
    cart = await r.json();
    afterCart();
  }
  function afterCart() {
    const c = $('#bagCount'); if (c) c.textContent = cart.item_count;
    if (bag && bag.open) renderBag();
    rerenderAll();
  }
  async function addVariants(lines, { quiet, src, name } = {}) {
    if (src) fly(src);
    try {
      await jsonPost(ROUTES.cartAdd + '.js', { items: lines.map(id => ({ id, quantity: 1 })) });
      await refreshCart();
      if (!quiet) toast(name ? `${name} added to your bag` : 'Added to your bag');
      return true;
    } catch (e) { toast(e.message); refreshCart().catch(() => {}); return false; }
  }
  function quickAdd(handle, el) {
    const p = CAT.get(handle);
    if (el && el.dataset.variant) return addVariants([+el.dataset.variant], { src: srcImg(el), name: p ? nameOf(p) : '' });
    if (!p) { if (el && el.dataset.url) location.href = el.dataset.url; return; }
    if ((p.variants || []).length > 1) return openSheet(handle);
    const v = firstVariant(p); if (!v || !v.available) return toast('This product is sold out.');
    return addVariants([v.id], { src: srcImg(el), name: nameOf(p) });
  }

  const bag = $('#bag');
  function openBag() { if (!bag) { location.href = ROUTES.cart; return; } renderBag(); if (!bag.open) bag.showModal(); }
  function meter(el, total) {
    if (!el) return;
    el.hidden = FREE <= 0;
    el.querySelector('.fill').style.width = Math.min(100, FREE ? total / FREE * 100 : 0) + '%';
    const left = FREE - total;
    el.querySelector('p').innerHTML = total === 0 ? `Free shipping on orders over <b>${money(FREE)}</b>.` : left > 0 ? `You're <b>${money(left)}</b> away from free shipping.` : 'Your order ships <b>free</b>.';
  }
  function suggestRow(p, text) {
    const v = firstVariant(p);
    return `<div class="suggest">${p.imgS ? `<img src="${p.imgS}" alt="" loading="lazy">` : '<span></span>'}<p>${text}</p><button class="s-add" type="button" data-add="${esc(p.handle)}">Add</button></div>`;
  }
  function renderBag() {
    if (!bag) return;
    const items = cart.items || [], have = stepsIn(), s = cart.total_price || 0;
    const tracker = $('#tracker');
    const missing = STEPS.filter(st => !have.has(st));
    const skinInBag = items.some(i => (CAT.get(i.handle) || {}).step);
    if (tracker) {
      tracker.innerHTML = STEPS.map(st => `<div class="${have.has(st) ? 'on' : ''}"><b>${NUM[st]}</b>${STEP[st]}</div>`).join('');
      $('#trackerNote').textContent = !items.length || !skinInBag ? '' : missing.length === 0 ? 'Your ritual is complete.' : `Add a ${missing.map(m => STEP[m].toLowerCase()).join(' and ')} step to complete your ritual.`;
    }
    $('#bagItems').innerHTML = items.length ? items.map(i => {
      const p = CAT.get(i.handle), nm = p ? nameOf(p) : i.product_title;
      const vt = i.product_has_only_default_variant ? '' : i.variant_title;
      return `<div class="li" data-key="${esc(i.key)}">${i.image ? `<img src="${sized(i.image, 200)}" alt="" loading="lazy">` : '<span class="ph"></span>'}
        <div><a class="nm" href="${esc(i.url)}">${esc(nm)}</a><div class="vr">${vt ? esc(vt) + ', ' : ''}<span class="num">${money(i.final_price)}</span></div>
        <div class="qty"><button type="button" data-dec="${esc(i.key)}" aria-label="Remove one">−</button><span class="num">${i.quantity}</span><button type="button" data-inc="${esc(i.key)}" aria-label="Add one">+</button></div></div>
        <div class="num">${money(i.final_line_price)}</div></div>`;
    }).join('') : `<p class="emptybag">Your bag is empty.<span>Start with the ritual, or take the skin quiz and we'll fill it for you.</span></p>`;
    let sg = '';
    if (items.length && skinInBag && missing.length && $('#tracker')) {
      const h = RITUAL.picks[missing[0]] || ([...CAT.values()].find(p => p.step === missing[0] && p.available) || {}).handle;
      const q = h && CAT.get(h);
      if (q && q.available) sg = suggestRow(q, `Complete step ${NUM[q.step || missing[0]]} with <b style="font-weight:500">${esc(nameOf(q))}</b>, <span class="num">${priceLabel(q)}</span>`);
    } else if (items.length && FREE > 0 && s < FREE) {
      const left = FREE - s;
      const q = [...CAT.values()].filter(p => p.step && p.available && !inBag(p.handle) && (p.variants || []).length === 1 && p.price >= left).sort((a, b) => a.price - b.price)[0];
      if (q) sg = suggestRow(q, `Add <b style="font-weight:500">${esc(nameOf(q))}</b> and your order ships free.`);
    }
    $('#bagSuggest').innerHTML = sg;
    $('#bagSub').textContent = money(s);
    meter($('#bagMeter'), s);
    const co = $('#checkout'); if (co) co.disabled = !items.length;
  }
  if (bag) bag.addEventListener('click', async e => {
    const i = e.target.closest('[data-inc]'), d = e.target.closest('[data-dec]');
    const b = i || d; if (!b) return;
    const key = b.dataset.inc || b.dataset.dec, line = (cart.items || []).find(x => x.key === key); if (!line) return;
    b.closest('.li').classList.add('busy');
    try { cart = await jsonPost(ROUTES.cartChange + '.js', { id: key, quantity: line.quantity + (i ? 1 : -1) }); afterCart(); }
    catch (err) { toast(err.message); refreshCart(); }
  });

  /* ---------- small pieces ---------- */
  let tt;
  function toast(m) { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2600); }
  function jumpTo(id) { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); return !!el; }
  const srcImg = el => { const box = el && el.closest('.card,.pick,.suggest'); return box && box.querySelector('img'); };
  function fly(src) {
    const target = $('#bagCount');
    if (RM || !src || !src.isConnected || !target) return;
    const s = src.getBoundingClientRect(), t = target.getBoundingClientRect(); if (!s.width) return;
    const f = src.cloneNode(); f.removeAttribute('loading'); f.removeAttribute('srcset'); f.className = 'flyer'; f.alt = '';
    Object.assign(f.style, { left: s.left + 'px', top: s.top + 'px', width: s.width + 'px', height: s.height + 'px' }); document.body.appendChild(f);
    const dx = t.left + t.width / 2 - (s.left + s.width / 2), dy = t.top + t.height / 2 - (s.top + s.height / 2);
    f.animate([{ transform: 'none', opacity: 1 }, { transform: `translate(${dx * .45}px,${dy * .45 - 70}px) scale(.5)`, opacity: 1, offset: .5 }, { transform: `translate(${dx}px,${dy}px) scale(.05)`, opacity: .4 }], { duration: 820, easing: 'cubic-bezier(.55,0,.3,1)' })
      .onfinish = () => { f.remove(); target.classList.remove('bump'); void target.offsetWidth; target.classList.add('bump'); };
  }
  function pickRow(p) {
    const done = inBag(p.handle), nm = esc(nameOf(p));
    return `${p.imgS ? `<img src="${p.imgS}" alt="" loading="lazy">` : '<span class="ph"></span>'}<div class="t"><a class="pname" href="${esc(p.url)}" data-open="${esc(p.handle)}">${nm}</a><span class="num">${priceLabel(p)}</span></div>`
      + (p.available ? `<button class="plus ${done ? 'done' : ''}" type="button" data-add="${esc(p.handle)}" aria-label="Add ${nm} to bag">${done ? '✓' : '+'}</button>` : '<span class="fineprint">Sold out</span>');
  }
  function card(p) {
    const done = inBag(p.handle), multi = (p.variants || []).length > 1, nm = esc(nameOf(p)), k = kickerOf(p);
    const btn = !p.available ? '<span class="quick soldout">Sold out</span>'
      : `<button class="quick ${done ? 'done' : ''}" type="button" data-quick="${esc(p.handle)}" aria-label="${multi ? 'Choose options for' : 'Add'} ${nm}${multi ? '' : ' to bag'}">${done ? 'In your bag' : multi ? 'Choose options' : 'Add to bag'}</button>`;
    return `<article class="card"><div class="tile"><a class="tile-link" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${p.img}" alt="${esc(p.alt || nameOf(p))}" loading="lazy">` : '<span class="ph"></span>'}</a>${btn}</div>
      <div class="meta">${k ? `<span class="stepname">${k}</span>` : ''}<div class="row"><h3><a href="${esc(p.url)}">${nm}</a></h3><span class="price num">${priceLabel(p)}</span></div>${p.line ? `<p class="line">${esc(p.line)}</p>` : ''}</div></article>`;
  }

  /* ---------- face map: x is across the photo, y down it; desktop and phone photos have their own positions ---------- */
  const FM = { sec: null, areas: [], area: null };
  function initFaceMap(sec) {
    const data = readJSON($('script[data-areas]', sec), { areas: [] });
    Object.assign(FM, { sec, areas: data.areas || [], quizLink: data.quizLink !== false, area: null, frame: $('[data-frame]', sec), zone: $('[data-zone]', sec), body: $('[data-area-body]', sec) });
  }
  function aim() {
    const a = FM.areas.find(x => x.k === FM.area), fr = FM.frame; if (!a || !fr) return;
    const ax = (narrow.matches ? a.xm : a.xd) + '%', ay = (narrow.matches ? a.ym : a.yd) + '%';
    fr.style.setProperty('--sx', ax); fr.style.setProperty('--sy', ay);
    fr.style.transformOrigin = `${ax} ${ay}`; fr.style.scale = RM ? '' : '1.22';
    if (narrow.matches) {
      const fh = fr.offsetHeight, hh = FM.sec.clientHeight, hy = fr.offsetTop + parseFloat(ay) / 100 * fh;
      fr.style.translate = `0 ${Math.max(-fh * .5, Math.min(0, hh * .26 - hy)).toFixed(1)}px`;
    } else fr.style.translate = '';
  }
  function renderArea(anim) {
    const a = FM.areas.find(x => x.k === FM.area); if (!a || !FM.body) return;
    const prods = a.ids.map(h => CAT.get(h)).filter(Boolean);
    const left = prods.filter(p => p.available && !inBag(p.handle)), tot = left.reduce((t, p) => t + (firstVariant(p) || {}).price, 0);
    const avail = prods.filter(p => p.available).length;
    const allLabel = !left.length ? 'All in your bag' : left.length === avail ? (left.length === 2 ? 'Add both' : `Add all ${WORDS[left.length] || left.length}`) : left.length === 1 ? 'Add the last one' : `Add the other ${WORDS[left.length] || left.length}`;
    $$('[data-area]', FM.sec).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.area === FM.area)));
    FM.body.innerHTML = `<div class="area"><h2 tabindex="-1" data-area-title>${esc(a.n)}</h2>${a.d ? `<p class="d">${esc(a.d)}</p>` : ''}
      <div class="rows ${anim ? 'anim' : ''}">${prods.map((p, i) => `<div class="pick" style="--i:${i}">${pickRow(p)}</div>`).join('')}</div>
      <div class="foot">${avail > 1 ? `<button class="btn ghost" type="button" data-addall="${esc(a.k)}" ${left.length ? '' : 'disabled'}>${allLabel}${left.length ? `, <span class="num">${money(tot)}</span>` : ''}</button>` : ''}${FM.quizLink && QUIZ.cfg ? '<button class="link" type="button" data-quiz>Not sure? Take the skin quiz</button>' : ''}</div></div>`;
  }
  function openArea(k) {
    if (!FM.sec) return;
    const was = !!FM.area; FM.area = k; FM.sec.classList.add('open'); FM.zone.inert = false;
    renderArea(true); aim(); setSolid();
    if (!was) { const t = $('[data-area-title]', FM.sec); if (t) t.focus({ preventScroll: true }); }
  }
  function closeArea() {
    if (!FM.area) return;
    FM.area = null; FM.sec.classList.remove('open'); FM.zone.inert = true;
    FM.frame.style.translate = ''; FM.frame.style.scale = '';
    $$('[data-area]', FM.sec).forEach(b => b.setAttribute('aria-pressed', 'false')); setSolid();
  }
  narrow.addEventListener('change', aim);
  addEventListener('resize', () => { if (FM.area) aim(); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && FM.area && !$('dialog[open]')) closeArea(); });

  /* ---------- shop with filters: one choice per group, combined; option counts reflect the other choices ---------- */
  const SHOP = { sec: null };
  let F = { cat: 'all', step: '', concern: '', area: '', sort: 'featured' }, query = '';
  function initFinder(sec) {
    const cfg = readJSON($('script[data-finder-config]', sec), {});
    Object.assign(SHOP, { sec, cfg, order: cfg.order || [], drawer: $('[data-fdrawer]', sec) });
    const params = new URLSearchParams(location.search), f = params.get('filter');
    if (f && /^(cat|step|concern|area):[\w-]+$/.test(f)) { const [k, v] = f.split(':'); F = { ...F, [k]: v }; }
    const sort = $('[data-sort]', sec); if (sort) sort.onchange = e => { F.sort = e.target.value; renderGrids(); };
    $('[data-fopen]', sec).onclick = () => { $('[data-fbody]', sec).innerHTML = groupsHTML(); SHOP.drawer.showModal(); };
    renderGrids();
  }
  const products = () => SHOP.order.map(h => CAT.get(h)).filter(Boolean);
  const catOf = p => p.cat || 'other';
  function groups() {
    const P = products(), g = SHOP.cfg.groups || {};
    const out = [];
    if (g.step !== false && P.some(p => NUM[p.step])) out.push({ k: 'step', n: 'Ritual step', o: STEPS.map(s => [s, `${NUM[s]}. ${STEP[s]}`]) });
    if (g.concern !== false && P.some(p => (p.c || []).length)) out.push({ k: 'concern', n: 'Concern', o: [['dryness', 'Dryness'], ['pores', 'Pores'], ['dullness', 'Dull tone'], ['lines', 'Fine lines']] });
    if (g.area !== false && FM.areas.length) out.push({ k: 'area', n: 'Face area', o: FM.areas.map(a => [a.k, a.t]) });
    return out;
  }
  function matches(p, f) {
    const q = query.trim().toLowerCase();
    const area = f.area && FM.areas.find(a => a.k === f.area);
    return (f.cat === 'all' || catOf(p) === f.cat) && (!f.step || p.step === f.step) && (!f.concern || (p.c || []).includes(f.concern))
      && (!f.area || (area && area.ids.includes(p.handle))) && (!q || [nameOf(p), p.title, p.line, p.step, catOf(p)].join(' ').toLowerCase().includes(q));
  }
  const countWith = (k, v) => products().filter(p => matches(p, { ...F, [k]: v })).length;
  function groupsHTML() {
    return groups().map(g => `<div class="fgroup"><h3>${g.n}</h3>${g.o.map(([v, l]) => {
      const n = countWith(g.k, v), on = F[g.k] === v;
      return `<button class="fopt" type="button" data-fg="${g.k}" data-fv="${esc(v)}" aria-pressed="${on}" ${!n && !on ? 'disabled' : ''}><span>${esc(l)}</span><span class="n num">${n}</span></button>`;
    }).join('')}</div>`).join('');
  }
  function renderGrids() {
    const sec = SHOP.sec; if (!sec) return;
    let list = products().filter(p => matches(p, F));
    if (F.sort === 'low') list = [...list].sort((a, b) => a.price - b.price); else if (F.sort === 'high') list = [...list].sort((a, b) => b.price - a.price);
    $('[data-shop-title]', sec).textContent = query.trim() ? `Results for “${query.trim()}”` : (SHOP.cfg.heading || 'Shop all');
    const present = Object.keys(CATS).filter(c => products().some(p => catOf(p) === c));
    $('[data-cats]', sec).innerHTML = present.length > 1 ? [['all', 'All'], ...present.map(c => [c, CATS[c]])].map(([v, l]) => `<button class="chip" type="button" data-fg="cat" data-fv="${v}" aria-pressed="${F.cat === v}">${l}<span class="num">${countWith('cat', v)}</span></button>`).join('') : '';
    const G = groups();
    $('[data-fside]', sec).innerHTML = groupsHTML();
    $('.shopgrid', sec).classList.toggle('nofilters', !G.length);
    $('[data-fopen]', sec).hidden = !G.length;
    if (SHOP.drawer.open) $('[data-fbody]', sec).innerHTML = groupsHTML();
    const na = ['step', 'concern', 'area'].filter(k => F[k]).length;
    $('[data-fcount]', sec).textContent = na || '';
    $('[data-fopen]', sec).setAttribute('aria-label', na ? `Filters, ${na} on` : 'Filters');
    $('[data-fshow]', sec).textContent = `Show ${list.length} product${list.length === 1 ? '' : 's'}`;
    $('[data-rcount]', sec).textContent = `${list.length} product${list.length === 1 ? '' : 's'}`;
    const chips = G.flatMap(g => { const o = F[g.k] && g.o.find(x => x[0] === F[g.k]); return o ? [`<button class="chip on" type="button" data-fg="${g.k}" data-fv="${esc(o[0])}" aria-label="Remove filter ${esc(o[1])}">${esc(o[1])} <span aria-hidden="true">×</span></button>`] : []; });
    if (query.trim()) chips.push(`<button class="chip on" type="button" data-fq aria-label="Clear search">“${esc(query.trim())}” <span aria-hidden="true">×</span></button>`);
    $('[data-activef]', sec).innerHTML = chips.length ? chips.join('') + '<button class="link" type="button" data-fclear>Clear all</button>' : '';
    $('[data-grid]', sec).innerHTML = list.length ? list.map(card).join('')
      : `<div class="empty"><p>No products match ${query.trim() ? 'your search' : 'these filters'}.</p><button class="btn ghost" type="button" data-fclear>Clear filters</button>${query.trim() ? `<a class="link" href="${ROUTES.search}?q=${encodeURIComponent(query.trim())}">Search the whole store</a>` : ''}</div>`;
    // header links only for groups that have products
    $$('#shopPanel [data-filter]').forEach(a => { const [k, v] = a.dataset.filter.split(':'); if (k === 'cat' && v !== 'all') a.hidden = !present.includes(v) || present.length < 2; if (k === 'step' || k === 'concern') a.hidden = !products().some(p => k === 'step' ? p.step === v : (p.c || []).includes(v)); });
  }
  function setFilter(spec) {
    const [k, v] = spec.split(':'); F = { ...F, cat: 'all', step: '', concern: '', area: '', [k]: v };
    query = ''; const q = $('#q'); if (q) q.value = '';
    renderGrids(); jumpTo('shop');
  }

  /* ---------- ritual ---------- */
  const RITUAL = { sec: null, picks: {} };
  function initRitual(sec) { RITUAL.sec = sec; RITUAL.picks = readJSON($('script[data-ritual-picks]', sec), {}) || {}; renderRitual(); }
  function renderRitual() {
    if (!RITUAL.sec) return;
    $$('.step[data-step]', RITUAL.sec).forEach(st => { const p = CAT.get(RITUAL.picks[st.dataset.step]); const box = $('[data-pick]', st); if (p && box) box.innerHTML = pickRow(p); });
  }

  /* ---------- quick view ---------- */
  const sheet = $('#sheet');
  function openSheet(handle) {
    const p = CAT.get(handle);
    if (!p || !sheet) { if (p) location.href = p.url; return; }
    const opts = (p.options || []).filter(o => o !== 'Title' || (p.variants || []).length > 1);
    const multi = (p.variants || []).length > 1;
    let sel = ((firstVariant(p) || {}).options || []).slice();
    const find = () => (p.variants || []).find(v => (v.options || []).every((o, i) => o === sel[i]));
    const kick = p.step && NUM[p.step] ? `Step ${NUM[p.step]}, ${STEP[p.step].toLowerCase()}` : (p.cat && CATS[p.cat] && p.cat !== 'other' ? CATS[p.cat] : '');
    const others = p.step && NUM[p.step] ? STEPS.filter(s => s !== p.step).map(s => CAT.get(RITUAL.picks[s])).filter(q => q && q.available && q.handle !== p.handle) : [];
    const pills = multi ? opts.map((name, i) => {
      const vals = [...new Set(p.variants.map(v => v.options[i]))];
      return `<div><p class="kicker" style="margin-bottom:8px">${esc(name)}</p><div class="vpills" role="radiogroup" aria-label="${esc(name)}">${vals.map(val => `<button class="vpill" type="button" role="radio" aria-checked="${val === sel[i]}" data-oi="${i}" data-ov="${esc(val)}"><b>${esc(val)}</b></button>`).join('')}</div></div>`;
    }).join('') : '';
    sheet.innerHTML = `<div class="inner"><div class="pic">${p.img ? `<img src="${p.img}" alt="${esc(p.alt || nameOf(p))}" data-simg>` : '<span class="ph"></span>'}</div><div class="txt">
      <div class="top"><span class="kicker" style="color:var(--rosewood)">${kick}</span><button class="x" type="button" data-close aria-label="Close">×</button></div>
      <h2 id="sheetTitle">${esc(nameOf(p))}</h2><p class="pr num" data-sprice>${money((find() || p).price)}</p>
      ${p.line ? `<p>${esc(p.line)}</p>` : p.desc ? `<p class="fineprint" style="font-size:16px">${esc(p.desc)}</p>` : ''}
      ${(p.b || []).filter(x => x.trim()).length ? `<ul>${p.b.filter(x => x.trim()).map(x => `<li>${esc(x.trim())}</li>`).join('')}</ul>` : ''}
      ${pills}
      ${p.use ? `<details open><summary>How to use</summary><p>${esc(p.use)}</p></details>` : ''}
      ${FREE > 0 ? `<details><summary>Shipping and returns</summary><p>Free shipping on orders over ${money(FREE)}, and your bag shows how close you are. Returns follow the store's return policy.</p></details>` : ''}
      ${others.length ? `<details open><summary>Completes the ritual</summary>${others.map(q => suggestRow(q, `<b style="font-weight:500">${esc(nameOf(q))}</b><br><span class="num" style="color:var(--muted)">Step ${NUM[q.step]}, ${priceLabel(q)}</span>`)).join('')}</details>` : ''}
      <div class="atc"><button class="btn" type="button" data-sadd></button><a class="link" href="${esc(p.url)}">View full details</a></div></div></div>`;
    const btn = $('[data-sadd]', sheet);
    function update() {
      const v = find();
      $('[data-sprice]', sheet).textContent = money(v ? v.price : p.price);
      btn.disabled = !v || !v.available;
      btn.innerHTML = !v ? 'Unavailable' : !v.available ? 'Sold out' : `Add to bag, <span class="num">${money(v.price)}</span>`;
      const im = $('[data-simg]', sheet); if (im && v && v.img) im.src = v.img;
    }
    $$('.vpill', sheet).forEach(b => b.onclick = () => {
      sel[+b.dataset.oi] = b.dataset.ov;
      $$(`.vpill[data-oi="${b.dataset.oi}"]`, sheet).forEach(x => x.setAttribute('aria-checked', String(x === b)));
      update();
    });
    btn.onclick = async () => { const v = find(); if (!v) return; btn.disabled = true; const ok = await addVariants([v.id], { quiet: true }); if (ok) { sheet.close(); openBag(); } else update(); };
    update();
    sheet.showModal();
  }

  /* ---------- skin quiz ---------- */
  const QUIZ = { cfg: null };
  const quiz = $('#quiz');
  const Q = [
    { k: 'feel', t: 'How does your skin feel by midday?', o: [['dry', 'Tight or flaky', 'Especially after washing'], ['oily', 'Shiny', 'Mostly on the forehead and nose'], ['combo', 'A bit of both', 'An oily T-zone, drier cheeks'], ['normal', 'Comfortable', 'You rarely think about it']] },
    { k: 'goal', t: 'What would you most like to change?', o: [['dryness', 'Dryness', 'Skin feels thirsty'], ['pores', 'Pores and blackheads', 'Nose, chin and forehead'], ['dullness', 'Dull tone', 'You want more glow'], ['lines', 'Fine lines', 'Around the eyes and forehead']] },
    { k: 'tex', t: 'How do you like to moisturize?', o: [['mist', 'A cooling mist', 'Light and refreshing'], ['cream', 'A tinted day cream', 'Moisture with a sheer tint'], ['stick', 'A swipe-on stick', 'Something you can carry']] }
  ];
  let qi = 0, ans = {};
  function quizResult() {
    const P = QUIZ.cfg.picks || {}, pick = (...slots) => slots.map(s => [s, P[s]]).find(([, h]) => h && CAT.get(h) && CAT.get(h).available);
    const c = pick(...(ans.goal === 'pores' || ans.feel === 'oily' ? ['cleanse_oily'] : ans.goal === 'dullness' ? ['cleanse_dull'] : []), 'cleanse_default', 'cleanse_oily', 'cleanse_dull');
    const t = pick(...(ans.goal === 'dryness' ? ['treat_dry'] : ans.goal === 'lines' ? ['treat_lines'] : []), 'treat_default', 'treat_dry', 'treat_lines');
    const h = pick('hydrate_' + ans.tex, 'hydrate_stick', 'hydrate_mist', 'hydrate_cream');
    return [c, t, h].filter(Boolean).map(([slot, handle]) => ({ slot, step: slot.split('_')[0], p: CAT.get(handle), why: (QUIZ.cfg.why || {})[slot] || '' }));
  }
  function renderQuiz() {
    const head = label => `<div class="top"><span class="stepof">${label}</span><button class="x" type="button" data-close aria-label="Close quiz">×</button></div>`;
    const side = QUIZ.cfg.side ? `<div class="side"><img src="${QUIZ.cfg.side}" alt=""></div>` : '<div class="side"></div>';
    if (qi < Q.length) {
      const q = Q[qi];
      quiz.innerHTML = `<div class="inner">${side}<div class="main">${head(`Question ${qi + 1} of ${Q.length}`)}<h2 id="quizTitle">${q.t}</h2>
        <div class="opts">${q.o.map(([v, b, s]) => `<button class="opt" type="button" data-v="${v}"><span><b>${b}</b><span>${s}</span></span></button>`).join('')}</div>
        <div class="qfoot">${qi ? '<button class="link" type="button" data-qback>Back</button>' : '<span></span>'}</div></div></div>`;
      $$('.opt', quiz).forEach(b => b.onclick = () => { ans[q.k] = b.dataset.v; qi++; renderQuiz(); });
      const bk = $('[data-qback]', quiz); if (bk) bk.onclick = () => { qi--; renderQuiz(); };
    } else {
      const r = quizResult(), tot = r.reduce((s, x) => s + (firstVariant(x.p) || {}).price, 0);
      quiz.innerHTML = `<div class="inner">${side}<div class="main">${head('Your ritual')}<h2 id="quizTitle">${r.length === 3 ? 'Three steps, picked for you' : 'Picked for you'}</h2>
        <div class="res">${r.map(x => `<div class="r"><span class="n">${NUM[x.step]}</span>${x.p.imgS ? `<img src="${x.p.imgS}" alt="">` : '<span></span>'}<div><div style="font-weight:500">${esc(nameOf(x.p))}</div><div class="why">${esc(x.why)}</div></div><span class="num">${money((firstVariant(x.p) || {}).price)}</span></div>`).join('')}</div>
        ${FREE > 0 ? '<div class="meter" data-qmeter><div class="track"><div class="fill"></div></div><p></p></div>' : ''}
        <div class="qfoot"><button class="link" type="button" data-qredo>Start over</button>${r.length ? `<button class="btn" type="button" data-qadd>Add ${r.length === 3 ? 'all three' : r.length === 2 ? 'both' : 'it'}, <span class="num">${money(tot)}</span></button>` : ''}</div></div></div>`;
      meter($('[data-qmeter]', quiz), (cart.total_price || 0) + tot);
      $('[data-qredo]', quiz).onclick = () => { qi = 0; ans = {}; renderQuiz(); };
      const add = $('[data-qadd]', quiz);
      if (add) add.onclick = async () => {
        add.disabled = true;
        r.forEach(x => { RITUAL.picks[x.step] = x.p.handle; });
        const ok = await addVariants(r.map(x => firstVariant(x.p).id), { quiet: true });
        renderRitual();
        if (ok) { quiz.close(); openBag(); } else add.disabled = false;
      };
    }
  }
  function openQuiz() {
    if (!QUIZ.cfg || !quiz) return false;
    closePanel(); qi = 0; ans = {}; renderQuiz(); quiz.showModal(); return true;
  }

  /* ---------- header ---------- */
  const bar = $('#bar'), panel = $('#shopPanel'), shopT = $('#shopToggle');
  // clear over the studio wall at rest; solid once the page scrolls, the Shop panel opens, or the phone sheet pans the photo under it
  function setSolid() { if (bar) bar.classList.toggle('solid', !FM.sec || (panel && !panel.hidden) || scrollY > 8 || (!!FM.area && narrow.matches)); }
  addEventListener('scroll', setSolid, { passive: true });
  function closePanel() { if (!panel) return; panel.hidden = true; shopT.setAttribute('aria-expanded', 'false'); setSolid(); }
  if (shopT) shopT.onclick = () => { panel.hidden = !panel.hidden; shopT.setAttribute('aria-expanded', String(!panel.hidden)); setSolid(); if (!panel.hidden) $('#q').focus(); };
  const qInput = $('#q');
  if (qInput) {
    qInput.addEventListener('input', e => { if (SHOP.sec) { query = e.target.value; renderGrids(); } });
    qInput.addEventListener('keydown', e => {
      if (e.key === 'Escape') closePanel();
      if (e.key === 'Enter' && SHOP.sec && query.trim()) { e.preventDefault(); closePanel(); jumpTo('shop'); }
    });
  }
  $('#bagOpen') && ($('#bagOpen').onclick = e => { if (bag) { e.preventDefault(); openBag(); } });

  /* ---------- product page ---------- */
  function initPDP(sec) {
    const p = CAT.get(sec.dataset.handle), form = $('[data-product-form]', sec); if (!p || !form) return;
    const idInput = $('[data-variant-id]', form), btn = $('[data-add-btn]', form), price = $('[data-price]', sec), track = $('.gtrack', sec);
    const find = () => { const sel = []; $$('input[data-opt]:checked', form).forEach(r => { sel[+r.dataset.opt] = r.value; }); return p.variants.find(v => v.options.every((o, i) => o === sel[i])); };
    form.addEventListener('change', e => {
      if (!e.target.matches('input[data-opt]')) return;
      const v = find();
      btn.disabled = !v || !v.available;
      btn.innerHTML = !v ? 'Unavailable' : !v.available ? 'Sold out' : `Add to bag, <span class="num">${money(v.price)}</span>`;
      if (!v) return;
      idInput.value = v.id; price.textContent = money(v.price);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      if (v.img && track) { const base = v.img.split('?')[0]; const img = $$('img', track).find(i => (i.currentSrc || i.src).split('?')[0] === base); if (img) track.scrollTo({ left: img.closest('figure').offsetLeft, behavior: RM ? 'auto' : 'smooth' }); }
    });
    form.addEventListener('submit', async e => {
      e.preventDefault(); if (btn.disabled) return;
      btn.disabled = true;
      const ok = await addVariants([+idInput.value], { quiet: true, src: $('.gimg img', sec) });
      btn.disabled = false;
      if (ok) openBag();
    });
    if (track) { const pos = $('[data-gpos]', sec); track.addEventListener('scroll', () => { if (pos) pos.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1; }, { passive: true }); }
  }

  /* ---------- collection and search filters: submit on change, without empty values ---------- */
  function initListing(sec) {
    const form = $('form[data-autoform]', sec); if (!form) return;
    const go = () => { const params = new URLSearchParams(); for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') params.append(k, v); location.href = form.action + (params.toString() ? '?' + params : ''); };
    form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox], select, input[type=number]')) go(); });
    form.addEventListener('submit', e => { e.preventDefault(); go(); });
    const t = $('[data-cftoggle]', sec);
    if (t) t.onclick = () => { const g = form; const open = !g.classList.contains('fopen'); g.classList.toggle('fopen', open); t.setAttribute('aria-expanded', String(open)); };
  }

  /* ---------- recommendations, loaded after the page ---------- */
  function initRecs(sec) {
    if (!sec.dataset.url || sec.dataset.loaded) return; sec.dataset.loaded = '1';
    fetch(sec.dataset.url).then(r => r.text()).then(t => {
      const doc = new DOMParser().parseFromString(t, 'text/html'), got = doc.querySelector('[data-recs]');
      if (got && got.innerHTML.trim()) { sec.innerHTML = got.innerHTML; loadCatalog(sec); }
    }).catch(() => {});
  }

  /* ---------- cart page: the free shipping line ---------- */
  $$('[data-static-meter]').forEach(m => meter(m, +m.dataset.total || 0));

  /* ---------- re-render everything that shows "in your bag" ---------- */
  function rerenderAll() {
    if (SHOP.sec) renderGrids();
    if (FM.area) renderArea(false);
    renderRitual();
    $$('.card .quick[data-variant]').forEach(b => { const h = b.dataset.quick; if (inBag(h)) { b.classList.add('done'); b.textContent = 'In your bag'; } });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    const ar = t.closest('[data-area]'); if (ar && FM.sec && FM.sec.contains(ar)) { if (ar.dataset.area !== FM.area) openArea(ar.dataset.area); return; }
    if (t.closest('[data-zclose]')) { closeArea(); return; }
    if (FM.area && t.closest('[data-frame]')) { closeArea(); return; }
    const aa = t.closest('[data-addall]');
    if (aa) {
      const A = FM.areas.find(x => x.k === aa.dataset.addall), ps = A.ids.map(h => CAT.get(h)).filter(p => p && p.available && !inBag(p.handle));
      if (!ps.length) return;
      fly($('.pick img', FM.body)); aa.disabled = true;
      addVariants(ps.map(p => firstVariant(p).id), { quiet: true }).then(ok => { if (ok) toast(ps.length === 1 ? `${nameOf(ps[0])} added to your bag` : ps.length === 2 && A.ids.length === 2 ? 'Both added to your bag' : `${(WORDS[ps.length] || ps.length).toString().replace(/^./, c => c.toUpperCase())} products added to your bag`); });
      return;
    }
    const q = t.closest('[data-quick]'); if (q) { e.preventDefault(); quickAdd(q.dataset.quick, q); return; }
    const a = t.closest('[data-add]');
    if (a) {
      const p = CAT.get(a.dataset.add); if (!p) return;
      const inDialog = a.closest('dialog');
      if ((p.variants || []).length > 1 && !inDialog) { openSheet(p.handle); return; }
      const v = firstVariant(p); if (!v || !v.available) { toast('This product is sold out.'); return; }
      addVariants([v.id], { src: inDialog ? null : srcImg(a), name: nameOf(p), quiet: !!inDialog }).then(ok => { if (ok && inDialog && a.isConnected) { a.textContent = 'Added'; a.disabled = true; } });
      return;
    }
    const o = t.closest('[data-open]'); if (o && CAT.get(o.dataset.open) && sheet) { e.preventDefault(); openSheet(o.dataset.open); return; }
    const qz = t.closest('[data-quiz]'); if (qz) { if (openQuiz()) e.preventDefault(); return; }
    const fg = t.closest('[data-fg]'); if (fg && SHOP.sec) { const k = fg.dataset.fg, v = fg.dataset.fv; F[k] = k === 'cat' ? v : (F[k] === v ? '' : v); renderGrids(); return; }
    if (t.closest('[data-fclear]') && SHOP.sec) { F = { ...F, cat: 'all', step: '', concern: '', area: '' }; query = ''; if (qInput) qInput.value = ''; renderGrids(); return; }
    if (t.closest('[data-fq]') && SHOP.sec) { query = ''; if (qInput) qInput.value = ''; renderGrids(); return; }
    const f = t.closest('[data-filter]'); if (f && SHOP.sec) { e.preventDefault(); closePanel(); setFilter(f.dataset.filter); return; }
    const j = t.closest('[data-jump]'); if (j && document.getElementById(j.dataset.jump)) { e.preventDefault(); closePanel(); jumpTo(j.dataset.jump); return; }
    if (t.closest('[data-toggle-recover]')) { const r = $('#recover'); if (r) { e.preventDefault(); r.classList.toggle('show'); } return; }
    if (t.closest('[data-close]')) { const d = t.closest('dialog'); if (d) d.close(); return; }
    if (t.tagName === 'DIALOG') t.close();
    if (panel && !panel.hidden && !t.closest('#bar')) closePanel();
  });

  /* ---------- motion: scroll reveals (movement only, content is never hidden) and gentle parallax ---------- */
  function initMotion() {
    if (RM || CFG.motion === false || !('IntersectionObserver' in window) || html.classList.contains('shopify-design-mode')) return;
    html.classList.add('motion');
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
    $$('.rv').forEach(el => io.observe(el));
    const fw = FM.sec && $('.fwrap', FM.sec), par = $$('[data-par]');
    let tick = false;
    const frame = () => {
      tick = false; const y = scrollY, h = innerHeight;
      if (fw && y < h * 1.3) { fw.style.translate = `0 ${(y * .3).toFixed(1)}px`; FM.sec.style.setProperty('--fade', Math.max(0, 1 - y / (h * .6)).toFixed(3)); }
      par.forEach(el => { const b = el.parentElement.getBoundingClientRect(); if (b.bottom < -50 || b.top > h + 50) return; const k = (b.top + b.height / 2 - h / 2) / (h + b.height); el.style.translate = `0 ${(-k * +el.dataset.par * 2).toFixed(1)}px`; });
    };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(frame); } }, { passive: true }); frame();
  }

  /* ---------- start, and re-start sections the theme editor reloads ---------- */
  function initSections(root) {
    const fm = root.matches && root.matches('[data-face-map]') ? root : $('[data-face-map]', root); if (fm) initFaceMap(fm);
    const qz = root.matches && root.matches('[data-quiz-section]') ? root : $('[data-quiz-section]', root); if (qz) QUIZ.cfg = readJSON($('script[data-quiz-config]', qz), null);
    const rt = root.matches && root.matches('[data-ritual]') ? root : $('[data-ritual]', root); if (rt) initRitual(rt);
    const fd = root.matches && root.matches('[data-finder]') ? root : $('[data-finder]', root); if (fd) initFinder(fd);
    $$('[data-pdp]', root).forEach(initPDP);
    $$('[data-listing]', root).forEach(initListing);
    $$('[data-recs]', root).forEach(initRecs);
  }
  loadCatalog();
  initSections(document);
  setSolid();
  initMotion();
  if (location.hash === '#quiz') { if (openQuiz()) history.replaceState(null, '', location.pathname + location.search); }
  if (bag && /[?&]bag=open\b/.test(location.search)) openBag();

  document.addEventListener('shopify:section:load', e => { loadCatalog(e.target); initSections(e.target); setSolid(); });
  document.addEventListener('shopify:block:select', e => { const b = e.target.closest && e.target.closest('.hs'); if (b && FM.sec && FM.sec.contains(b)) openArea(b.dataset.area); });
  document.addEventListener('shopify:block:deselect', () => closeArea());
})();
